import { render, staticRenderFns } from "./Reward.vue?vue&type=template&id=ab9c6a06&scoped=true&"
import script from "./Reward.vue?vue&type=script&lang=js&"
export * from "./Reward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab9c6a06",
  null
  
)

export default component.exports